<template>
  <div>
    <v-form id="js-via-form" ref="fourMatForm">
      <v-container>
        <v-row>
          <v-switch
            id="js-4-mat-visible-toggle"
            class="mx-2"
            v-model="visibleValue"
            label="Visible To Mentee"
          ></v-switch>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              id="js-q1"
              label="Q1 Value"
              v-model="q1"
              :rules="valueRules"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              id="js-q2"
              label="Q2 Value"
              v-model="q2"
              :rules="valueRules"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              id="js-q3"
              label="Q3 Value"
              v-model="q3"
              :rules="valueRules"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              id="js-q4"
              label="Q4 Value"
              v-model="q4"
              :rules="valueRules"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              id="js-quadrant"
              label="Quadrant"
              v-model="quadrant"
              :rules="quadrantRules"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn
              class="ma-4"
              id="js-add-four-mat-button"
              color="secondary"
              @click="update4Mat()"
              large
            >
              Add 4MAT Results Data
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"

export default {
  mixins: [eventMixin],
  props: {
    userId: { type: Number },
    v1: { type: Number },
    v2: { type: Number },
    v3: { type: Number },
    v4: { type: Number },
    quadrantPrimary: { type: Number },
    visible: { type: Boolean }
  },
  data: function() {
    return {
      q1: "",
      q2: "",
      q3: "",
      q4: "",
      quadrant: "",
      visibleValue: false,
      valueRules: [
        v => (parseInt(v) >= 0 && parseInt(v) <= 60) || "Values 0 to 60 Only"
      ],
      quadrantRules: [
        v => (parseInt(v) >= 0 && parseInt(v) <= 4) || "Values 0 to 4 Only"
      ]
    }
  },
  created() {
    this.q1 = this.v1
    this.q2 = this.v2
    this.q3 = this.v3
    this.q4 = this.v4
    this.quadrant = this.quadrantPrimary
    this.visibleValue = this.visible
  },
  methods: {
    update4Mat() {
      if (this.$refs.fourMatForm.validate()) {
        this.fireEvent("four_mat_result:add", {
          userId: this.userId,
          q1: this.q1,
          q2: this.q2,
          q3: this.q3,
          q4: this.q4,
          quadrant: this.quadrant,
          visible: this.visibleValue
        })
      } else {
        console.log("not updating because form did not validate")
      }
    }
  }
}
</script>
